// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {
//   UilArchive,
//   UilExclamationCircle,
//   UilInbox,
//   UilLocationArrow,
//   UilPen,
//   UilStar,
//   UilTrash
// } from '@iconscout/react-unicons';
// import team60 from 'assets/img/team/60.webp';
// import team58 from 'assets/img/team/58.webp';
// import team57 from 'assets/img/team/57.webp';
// import team59 from 'assets/img/team/59.webp';
// import team30 from 'assets/img/team/30.webp';
// import { faCircle } from '@fortawesome/free-solid-svg-icons';

export interface SidebarItem {
  icon: JSX.Element;
  label: string;
  count?: number;
  link?: string;
  active?: boolean;
}

export interface MediaModel {
  mediaId: string;
  name?: string;
  url: string;
  contentType: string; //image/webp
  starred: boolean;
  tags?: string[];
  createdDate?: Date;
  createdBy?: string;
  modifiedDate?: Date | null;
  modifiedBy?: string;
  deletedDate?: Date | null;
  deletedBy?: string;
}

export const media: MediaModel[] = [
  {
    mediaId: '',
    name: 'Image 4',
    url: 'https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/nupitch_f7533443-7bcc-419d-abc4-3b17a1169a92_51_bg_img.png',
    contentType: 'image/webp',
    starred: true,
    tags: ['Horror', 'Scary', 'Spooky', 'Halloween'],
    createdDate: new Date()
  },
  {
    mediaId: '',
    name: 'Image 5',
    url: 'https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/nupitch_f7533443-7bcc-419d-abc4-3b17a1169a92_52_bg_img.png',
    contentType: 'image/webp',
    starred: true,
    tags: ['Dogs', 'Puppies', 'Cute'],
    createdDate: new Date()
  },
  {
    mediaId: '',
    name: 'Image 6',
    url: 'https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/nupitch_f7533443-7bcc-419d-abc4-3b17a1169a92_53_bg_img.png',
    contentType: 'image/webp',
    starred: true,
    tags: ['Kids', 'Children', 'Cute'],
    createdDate: new Date()
  },
  {
    mediaId: '',
    name: 'Image 7',
    url: 'https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/nupitch_f7533443-7bcc-419d-abc4-3b17a1169a92_54_bg_img.png',
    contentType: 'image/webp',
    starred: true,
    tags: ['Nature', 'Trees', 'Green'],
    createdDate: new Date()
  },
  {
    mediaId: '',
    name: 'Image 1',
    url: 'https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/nupitch_f7533443-7bcc-419d-abc4-3b17a1169a92_61_bg_img.png',
    contentType: 'image/webp',
    starred: true,
    tags: ['romantic', 'love', 'couple', 'kiss'],
    createdDate: new Date()
  },
  {
    mediaId: '',
    name: 'Image 2',
    url: 'https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/nupitch_f7533443-7bcc-419d-abc4-3b17a1169a92_37_bg_img.png',
    contentType: 'image/webp',
    starred: false,
    tags: ['Winter', 'Cerebral', 'Chill'],
    createdDate: new Date()
  },
  {
    mediaId: '',
    name: 'Image 3',
    url: 'https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/nupitch_f7533443-7bcc-419d-abc4-3b17a1169a92_38_bg_img.png',
    contentType: 'image/webp',
    starred: true,
    tags: ['summer', 'chill', 'beach', 'ocean'],
    createdDate: new Date()
  }
];
